module.exports = __webpack_public_path__ + "img/titleImg.6f81132b.png";